import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "brd-about",
  templateUrl: "./about.component.html",
  styleUrl: "./about.component.less",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AboutComponent {}
